// extracted by mini-css-extract-plugin
export default {"button":"ButtonProgress_button__BhZSe","progress":"ButtonProgress_progress__jKp++","label":"ButtonProgress_label__io5xd"};